import { useMutation } from '@tanstack/react-query';

import * as fakeAPI from '_modules/message/services/fake';
import * as httpAPI from '_modules/message/services/http';
import { TMessageAskVariables } from '_modules/message/types/service';

const api = import.meta.env.VITE_API_MODE === 'http' ? httpAPI : fakeAPI;

export const useAskMessage = () =>
  useMutation({
    mutationFn: async ({ onDelta, ...data }: TMessageAskVariables) => {
      const { data: response } = await api.askMessage(data, { onDelta });

      return response;
    },
  });
